/* global appData, $ */

import events from '../utils/events';
import fireEvent from '../utils/fireEvent';
import hideLoading from '../utils/loading/hideLoading';
import showLoading from '../utils/loading/showLoading';
import framePage from '../utils/framePage';
import sendMessageToParent from '../utils/sendMessageToParent';

function enableSubmit() {
	hideLoading(framePage.$signInBtn, '');
}

function handleError(status) {
	let eventName;
	switch (status) {
		case 'invalidCredentials': {
			eventName = 'sign in : failed';
			break;
		}
		case 'accountLocked': {
			eventName = 'sign in : failed : account lockout';
			break;
		}
		case 'imsUnknown':
		case 'badRequest':
		default: {
			eventName = 'sign in : network error';
		}
	}

	fireEvent(eventName);
	enableSubmit();

	$('#signInForm')
		.find('input')
		.first()
		.focus();
}

function getValidationMessages($form) {
	const errorMessageElems = $form.find('.errorMessage');
	return errorMessageElems
		.map((index, elem) => ({
			field: elem.id.replace('LabelErrorMessage', ''),
			message: $(elem).text()
		}))
		.toArray();
}

function submitForm({ valid, element }) {
	// Accessibility - focus the first error
	const $form = $(element);
	if (!valid) {
		$form
			.find('input.error')
			.first()
			.focus();
		sendMessageToParent(events.SIGNIN_MALFORMED, { messages: getValidationMessages($form) });
	}
	if (!valid || !framePage.allowSubmit) {
		return false;
	}
	showLoading(framePage.$signInBtn);
	const ajaxData = {
		password: framePage.$password.val().trim(),
		username: framePage.$username.val().trim()
	};
	if (framePage.accessToken && framePage.facebookId) {
		ajaxData.accessToken = framePage.accessToken;
		ajaxData.facebookId = framePage.facebookId;
	}
	$.ajax({
		type: 'POST',
		url: `${appData.appPath}/signin/frame/authenticate`,
		contentType: 'application/json',
		processData: false,
		data: JSON.stringify(ajaxData),
		dataType: 'json',
		success(data) {
			switch (data.status) {
				case 'attCreated': {
					fireEvent('sign in : success');
					sendMessageToParent(events.SIGNIN_COMPLETE, {
						userId: data.userId,
						type: 'standard',
						passwordReset: data.passwordReset
					});
					break;
				}
				case 'multipleUsers': {
					sendMessageToParent(events.SIGNIN_MULTI_ACCOUNT, { email: data.email });
					$('main.page').addClass('noDisplay');
					$('#accountSelectWrp').removeClass('noDisplay');
					enableSubmit();
					$('#accountSelectForm')
						.get(0)
						.hydrate(data.users);
					$('#accountSelectForm').one('ACCOUNT_SELECTED', (e, user) => {
						$('main.page').removeClass('noDisplay');
						$('#accountSelectWrp').addClass('noDisplay');
						$('#username').val(user.username);
						$('#signInBtn').click();
						sendMessageToParent(events.SIGNIN_MULTI_ACCOUNT_SELECTED);
					});
					break;
				}
				case 'mfa': {
					fireEvent('MFA : modal shown');
					const prefix = appData.queryString ? '&' : '';
					window.location = `${appData.appPath}/signin/frame/mfa?${appData.queryString}${prefix}sms=${data.sms}`;
					return;
				}
				case 'invalidCredentials': {
					$('#username')
						.addClass('error')
						.removeClass('success');
					$('#password')
						.addClass('error')
						.removeClass('success');
					$('#usernameLabel')
						.addClass('error')
						.removeClass('success');
					$('#passwordLabel')
						.addClass('error')
						.removeClass('success');
					sendMessageToParent(events.SIGNIN_INVALID_CREDENTIALS);
					handleError(data.status, data.html);
					break;
				}
				case 'accountLocked': {
					sendMessageToParent(events.SIGNIN_ACCOUNT_LOCKED);
					handleError(data.status, data.html);
					break;
				}
				case 'badRequest':
				case 'imsUnknown':
				default: {
					sendMessageToParent(events.SIGNIN_SERVER_ERROR);
					handleError(data.status, data.html);
				}
			}
		},
		error({ status }) {
			if (status > 0) {
				sendMessageToParent(events.SIGNIN_SERVER_ERROR);
			} else {
				sendMessageToParent(events.SIGNIN_NETWORK_ERROR);
			}
			handleError();
		}
	});
}

export default submitForm;
